// stores/user.js
import { DateTime } from 'luxon'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useInstallationStore = defineStore('installation', () => {
  const name = ref(null)
  const git = ref({
    branch: null,
    time: null,
    shortid: null,
    version: null,
  })

  const gitDate = computed(() =>
    git.value.time
      ? DateTime.fromSeconds(parseInt(git.value.time)).toLocaleString({ month: 'short', year: 'numeric' })
      : null
  )
  const jira_enabled = ref(null)
  const help_center_url = ref(null)
  const logo_src = ref(null)
  const catalogEnabled = ref(null)
  const sdlc_phase = ref(null)
  const require_integration_export_permission = ref(null)
  const debug_logging = ref({})
  const buildhelper_enabled = ref(null)
  const adapter_binding_require_user = ref(null)
  const default_experience = ref(null)
  const workbench_enabled = ref(false)
  const mapping_enabled = ref(null)

  async function updateInstallation(data) {
    name.value = data.installation
    git.value = data.git
    jira_enabled.value = data.jira_enabled
    help_center_url.value = data.help_center_url
    logo_src.value = data.logo
    catalogEnabled.value = data.catalog_enabled
    sdlc_phase.value = data.sdlc_phase
    mapping_enabled.value = data.mapping_enabled ?? true
    require_integration_export_permission.value = data.require_integration_export_permission
    debug_logging.value = data.debug_logging
      ? {
          enabled: data.debug_logging.enabled,
          expiration: DateTime.fromISO(data.debug_logging.expiration, { zone: "utc" })
        }
      : {}
    buildhelper_enabled.value = data.buildhelper_enabled
    adapter_binding_require_user.value = data.adapter_binding_require_user
    default_experience.value = data.default_experience
    workbench_enabled.value = data.workbench_enabled ?? false
  }

  return {
    name,
    git,
    logo_src,
    jira_enabled,
    help_center_url,
    gitDate,
    sdlc_phase,
    mapping_enabled,
    catalogEnabled,
    require_integration_export_permission,
    debug_logging,
    buildhelper_enabled,
    updateInstallation,
    adapter_binding_require_user,
    default_experience,
    workbench_enabled,
  }
})
